import { observable } from "mobx";
import EmpresaGloboService from "../../../services/EmpresaGloboService";

export default class EmpresaGloboStoreStore {

    @observable empresaGloboLista;
    @observable itemSelecionado;
    @observable loading;

    constructor(modalStore) {
        this.modalStore = modalStore;
        this.empresaGloboLista = [];
        this.resetItemSelecionado();
        this.empresaGloboService = new EmpresaGloboService();
    }

    resetItemSelecionado() {
        this.itemSelecionado = {
            id: 0,
            nome: "",
            grupoSalarial: "",
            codigoBu: '',
            percentualImpostoVR: 0.00
        };
    }

    carregarLista() {
        this.loading = true;

        const loadingPromises = Promise.all([

            this.empresaGloboService.list().then(response => {
                this.empresaGloboLista = response.data;
            }).catch(error => {
                console.log(error);
            })
        ])
        loadingPromises.then(
            () => {
                this.loading = false;
            }
        ).catch(
            (error) => this.loading = false
        )
    }

    setNome(value) {
        this.itemSelecionado.nome = value;
    }

    setCodigoEmpresa(value) {
        this.itemSelecionado.codigoFpw = value;
    }

    setGrupoSalarial(value) {
        this.itemSelecionado.grupoSalarial = value;
    }

    setCodigoBu(value) {
        if (value !== null) {
            if(value.length > 0) {
                this.itemSelecionado.codigoBu = value;
            }
        }
    }

    setEmailAprovadorLote(value) {
        if (value !== null) {
            if(value.length > 0) {
                this.itemSelecionado.emailAprovadorLote = value;
            }
        }
    }
    setPercentualImpostoVR(value){
        this.itemSelecionado.percentualImpostoVR = value;
    }

    toggleAtivo() {
        this.itemSelecionado.ativo = !this.itemSelecionado.ativo;
    }

    setLista(value) {
        this.empresaGloboLista = value;
    }

    editar() {
        let tabelaIndex = this.empresaGloboLista.findIndex((tabelaItem) => tabelaItem.id === this.itemSelecionado.id);
        return this.empresaGloboService.edit(this.itemSelecionado.id, this.itemSelecionado).then(response => {
            this.empresaGloboLista[tabelaIndex] = response.data;
        })
    }

    cadastrar() {
        return this.empresaGloboService.save(this.itemSelecionado).then(response => {
            this.empresaGloboLista.push(response.data);
        });
    }

    remover() {
        let tabelaIndex = this.empresaGloboLista.findIndex((tabelaItem) => tabelaItem.id === this.itemSelecionado.id);
        let modal = this.modalStore;

        return this.empresaGloboService.delete(this.itemSelecionado.id).then(response => {
            this.empresaGloboLista.splice(tabelaIndex, 1);
            modal.toggleModal()
        }).catch(error => {
            modal.setSubmitMensagemErro(error.response.data.message)
        })
    }

    preencherModal(row){
        if(row) {
            this.itemSelecionado = Object.assign({}, row);
        } else {
            this.resetItemSelecionado();
        }
    }
}